import * as THREE from 'three';
import type { PathCamera } from '../types/designer';

export interface MirroredWaypoint {
  position: [number, number, number];
  target: [number, number, number];
}

/**
 * 相机路径视点镜像（2026-10-14 修复用户反馈：点漫游后镜头只落到第一个相机、不移动）：
 * 「相机路径」（waypoints）应与轨道相机一致 —— N 台相机 = N 个视点（N-1 段），
 * 每个视点取该相机**最后一帧**的位姿：位置=关键帧位置，注视点=沿相机视线（-Z）方向 lookDistance 处。
 * 此前自动同步的是占位视点 [10,10,10]（与相机无关），播放时镜头停在占位点不动。
 */
export function mirrorWaypointsFromCameras(cameras: PathCamera[], lookDistance = 10): MirroredWaypoint[] {
  return cameras.map((cam) => {
    const f = cam.keyFrames[cam.keyFrames.length - 1];
    if (!f) return { position: [0, 0, 0], target: [0, 0, 0] };
    const forward = new THREE.Vector3(0, 0, -1).applyEuler(new THREE.Euler(f.rotation[0], f.rotation[1], f.rotation[2]));
    return {
      position: [f.position[0], f.position[1], f.position[2]],
      target: [
        f.position[0] + forward.x * lookDistance,
        f.position[1] + forward.y * lookDistance,
        f.position[2] + forward.z * lookDistance,
      ],
    };
  });
}
